import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';

export interface salesReturnDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface salesReturnDetailsDto {
    phBillRtnId: any;
    phBillRtnNo:number;
    phBatch: string;
    phExpDate:any;
    phSellRate:number;
    phQty: number;
    phSellAmount:number;
    phDiscPercentage:number;
    phDiscAmt:number;
    phDiscountValue:string;
    phDiscountwithAmount: number;
    phGSTPercentage:number;
    phGSTAmount:string;
    phGSTWithAmount:string;
    phNetAmount: number;
    phCostRate: number;
    phCosAmount:number;
    sellPriceStrip:number;

    phMrpRate:any;
    phMrpAmount:any;
    PhUnitMrpRate:number;
    PhStripMrpAmount:number;
    branchId:string;
    branch: string;
    tenantId:string;
    tenant: string;
    phMedicineId:string;
    schemePercentage?:string;
    schemeSellPrice?:string;
    parameters?: salesReturnDetailsParameter[];
    links?: any;
}


export abstract class salesReturnDetailsDtoData {
}
